import React from 'react'
import PenIcon from '../../Assets/Icons/panIcon.svg'
import Closeicon from '../../Assets/Icons/closeIcon.svg'

export default function UniversalCard (props) {
    return(
        <div className='w-full bg-[#F9FAFB] rounded-[8px] px-3 py-3 flex items-center justify-between'>
            <div className='flex items-center gap-2'>
               <div className='w-[2.2rem] h-[2.2rem] rounded-full bg-[#F3F4F6] flex items-center justify-center'>
                <img style={{width: props.width, height: props.height}} src={props.img} />
                </div>
                <div className='flex flex-col'>
                    <p className='text-[0.94rem] text-[#111928] font-[500]'>{props.name}</p>
                    <p className='text-[0.80rem] text-[#6B7280]'>{props.location}</p>
                </div>
            </div>
            <div className='flex items-center gap-3'>
                <img src={props.penicon} />
                <img src={props.closeicon} />
            </div>
        </div>
    )
}